define('shared/page/apiVersion',['$', 'shared/lib/RSVP'], function ($, RSVP) {
    'use strict';

    var ret = function(){
        var result = $('html').hasClass('is-new-house') ? ret.NEW_HOUSE : ret.OLD_HOUSE;
        return RSVP.resolve(result);
    };

    ret.NEW_HOUSE = 'new-house';
    ret.OLD_HOUSE = 'old-house';

    return ret;
});
